import React from 'react';
import { Modal, Tabs } from 'antd';
import DayTypeForm from '../Forms/DayTypeForm.js';

const { TabPane } = Tabs;

const ChangeDayTypeContainer = ({ state, user, ...props }) => {

  return (
    <Modal
      open={state.showItemContextModal}
      title={props.contextMenuSelection}
      onCancel={props.handleModalCancel}
      footer={[
      ]}
    >
        <Tabs defaultActiveKey="1">
           <TabPane tab={<p>Resource Day Type</p>} key="1">
             <DayTypeForm
               loading={state.loading}
               resource={state.resource}
               itemDetails={state.itemDetails}
               user={user}
               dayTypesAll={state.dayTypesAll}
               allowTourDayTypes={state.allowTourDayTypes}
               confirmDialogue={state.confirmDialogue}
               handleDayTypeDateChange={props.handleDayTypeDateChange}
               handleOmnibusFieldChange={props.handleOmnibusFieldChange}
               updateDayType={props.updateDayType}
               createDayType={props.createDayType}
               handleItemDelete={props.handleItemDelete}
             />
           </TabPane>
       </Tabs>
    </Modal>
  );

}

export default ChangeDayTypeContainer;
